import { render, staticRenderFns } from "./MatchingInfo.vue?vue&type=template&id=2d7788be&"
import script from "./MatchingInfo.vue?vue&type=script&lang=js&"
export * from "./MatchingInfo.vue?vue&type=script&lang=js&"
import style0 from "./MatchingInfo.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MatchingInfo.vue"
export default component.exports